import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clearAuthSession, getStoredUser } from "../../utils/authStorage";
import "../profile-components/Topbar.css";

const THEME_STORAGE_KEY = "agentBookTheme";

function SupportTopbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);

    if (savedTheme === "dark" || savedTheme === "light") {
      return savedTheme;
    }

    return window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });

  const storedUser = useMemo(() => getStoredUser(), []);

  const userDisplayName =
    storedUser?.name ||
    storedUser?.full_name ||
    storedUser?.first_name ||
    "Support";

  const pageTitle = useMemo(() => {
    if (location.pathname === "/support-admin") {
      return "Support Dashboard";
    }

    if (location.pathname === "/support-admin/tickets") {
      const params = new URLSearchParams(location.search);
      const status = params.get("status");

      if (status === "Closed") return "Closed Tickets";
      if (status) return `${status} Tickets`;

      return "Support Tickets";
    }

    if (location.pathname.startsWith("/support-admin/tickets/")) {
      return "Ticket Detail";
    }

    return "Support Workspace";
  }, [location.pathname, location.search]);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", theme === "dark");
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  }, [theme]);

  const toggleMobileSidebar = () => {
    window.dispatchEvent(new Event("toggle-mobile-sidebar"));
  };

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const handleLogout = () => {
    clearAuthSession();
    navigate("/login");
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          type="button"
          className="topbar-menu-btn"
          aria-label="Open navigation menu"
          onClick={toggleMobileSidebar}
        >
          ☰
        </button>

        <div className="topbar-context-pill">
          {pageTitle}
        </div>
      </div>

      <div className="topbar-right">
        <div className="topbar-actions">
          <button
            type="button"
            className="topbar-theme-btn"
            aria-label="Toggle dark mode"
            onClick={toggleTheme}
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>

          <div className="topbar-context-pill">
            {userDisplayName}
          </div>

          <button
            type="button"
            className="topbar-logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}

export default SupportTopbar;